var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-0 pa-6",attrs:{"min-width":"342px"}},[_c('div',[_c('div',{staticClass:"content-title font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("truncateAddress")(_vm.wallet.account,10, 6))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }